<template>
  <el-card :body-style="{ 'padding': '5px' }">
    <div slot="header">
      <el-row :gutter="24">
        <el-col :span="5">
          <el-checkbox
            size="sm"
            v-model="isShowRepassesMesAnterior"
          >Mês Anterior</el-checkbox>
        </el-col>
        <el-col :span="14">
          <b>
            Repasses Atrasados
          </b>
          <el-tooltip v-if="tooltipQuantidadeRepassesIsVisible || tooltipQuantidadeRepassesMesAnteriorIsVisible" :content="tooltipQuantidadeRepassesIsVisible ? quantidadeRepasses : quantidadDeRepassesMesAnterior">
            <i class="el-icon-info" style="color: #399" />
          </el-tooltip>
        </el-col>
      </el-row>
    </div>

    <div>
      <el-table
        :data="repasses"
        height="300"
        stripe
        border
        size="mini"
        highlight-current-row
        v-if="visibilidadeRepassesAtrasados"
        :empty-text="isLoading ? 'Carregando...' : 'Nenhum Repasse atrasado'"
      >
        <el-table-column
          prop="aluguel.idNaImobiliaria"
          label="Aluguel"
          width="100"
          show-overflow-tooltip
          sortable
        />

        <el-table-column
          prop="mesSerie"
          label="Mês"
          width="70"
          sortable
        />

        <el-table-column
          prop="cliente.nome"
          label="Cliente"
          show-overflow-tooltip
          sortable
        />

        <el-table-column
          prop="dataVencimento"
          label="Data do Repasse"
          show-overflow-tooltip
          width="150"
          sortable
        />

        <el-table-column
          prop="valor"
          label="Valor"
          width="150"
          :formatter="formatarValor"
          show-overflow-tooltip
          sortable
        />
      </el-table>
      <el-table
        :data="repassesMesAnterior"
        height="300"
        stripe
        border
        size="mini"
        highlight-current-row
        v-if="visibilidadeRepassesMesAnterior"
        :empty-text="isLoading ? 'Carregando...' : 'Nenhum Repasse atrasado no mês anterior'"
      >
        <el-table-column
          prop="aluguel.idNaImobiliaria"
          label="Aluguel"
          width="100"
          show-overflow-tooltip
          sortable
        />

        <el-table-column
          prop="mesSerie"
          label="Mês"
          width="70"
          sortable
        />

        <el-table-column
          prop="cliente.nome"
          label="Cliente"
          show-overflow-tooltip
          sortable
        />

        <el-table-column
          prop="dataVencimento"
          label="Data do Repasse"
          show-overflow-tooltip
          width="150"
          sortable
        />

        <el-table-column
          prop="valor"
          label="Valor"
          width="150"
          :formatter="formatarValor"
          show-overflow-tooltip
          sortable
        />
      </el-table>
    </div>
  </el-card>
</template>

<script>
import axios from 'axios';
import URLS from '../../util/urls';
import util from '../../util/funcoes';
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      repasses: [],
      repassesMesAnterior: [],
      isShowRepassesMesAnterior: false,
      isLoading: false,

      visibilidadeRepassesAtrasados: true,
      visibilidadeRepassesMesAnterior: false,

      payload: {
        dataVencimentoInicio: util.recuarPeriodoDaData(util.stringParaData(util.primeiroDiaMes()), 1),
        dataVencimentoFim: util.recuarPeriodoDaData(util.stringParaData(util.ultimoDiaMes()), 1) 
      }
    };
  },

  computed: {
    tooltipQuantidadeRepassesIsVisible() {
      return this.repasses.length > 0;
    },
    tooltipQuantidadeRepassesMesAnteriorIsVisible() {
      return this.repassesMesAnterior.length > 0;
    },
    quantidadeRepasses() {
      const quantidade = this.repasses.length;
      switch(quantidade) {
        case 1:
          return 'Exibindo 1 Repasse';
        default:
          return `Exibindo ${quantidade} Repasses`;
      }
    },
    quantidadDeRepassesMesAnterior() {
      const quantidade = this.repassesMesAnterior.length;
      switch(quantidade) {
        case 1:
          return 'Exibindo 1 Repasse';
        default:
          return `Exibindo ${quantidade} Repasses`;
      }
    }
  },

  watch: {
    'isShowRepassesMesAnterior': function(newValue, oldValue) {
      if(newValue != oldValue) {
        if(newValue === true) {
          this.listarRepassesMesAnterior(this.payload);
          this.visibilidadeRepassesAtrasados = false;
          this.visibilidadeRepassesMesAnterior = true;
        } else {
          this.listar();
          this.visibilidadeRepassesAtrasados = true;
          this.visibilidadeRepassesMesAnterior = false;
        }
      }
    }
  },

  created() {
    this.listar();
  },

  methods: {
    ...mapActions('loginStore', [
      'relogar',
    ]),

    listar() {
      this.showLoading();
      this.limparRepasses();
      this.recuperarRepassesAtrasados()
        .then()
        .finally(() => {
          this.hideLoading();
        });
    },

    listarRepassesMesAnterior(payload) {
      this.showLoading();
      this.limparRepasses();
      this.recuperarRepassesMesAnterior(payload)
      .then()
      .finally(() => {
        this.hideLoading();
      });
    },

    recuperarRepassesAtrasados() {
      return axios.get(URLS.DASHBOARD_RECUPERAR_REPASSES_ATRASADOS)
        .then(this.handleResultadoRecuperarRepassesAtrasados)
        .catch(error => {
          throw error;
        });
    },

    recuperarRepassesMesAnterior(payload) {
      return axios.post(URLS.DASHBOARD_RECUPERAR_REPASSES_MES_ANTERIOR, payload)
      .then(this.handleResultadoRecuperarRepassesMesAnterior)
      .catch(error => {
        throw error;
      });
    },

    handleResultadoRecuperarRepassesAtrasados(response) {
      switch(response.data.status) {
        case 'SESSAO_EXPIRADA':
          return this.relogar().then(authResponse => {
            if(authResponse.status === 'SUCESSO') {
              return this.recuperarRepassesAtrasados();
            }
          }).catch(error => {
            throw error;
          });

        case 'SUCESSO':
          this.repasses = [...response.data.lista];
          break;

        case 'ERRO':
          this.repasses = [];
      }
    },

    handleResultadoRecuperarRepassesMesAnterior(response) {
      switch (response.data.status) {
        case 'SESSAO_EXPIRADA':
          return this.relogar().then(authResponse => {
            if(authResponse.status === 'SUCESSO') {
              return this.recuperarRepassesMesAnterior(this.payload);
            }
          }).catch(error => {
            throw error;
          });
        case 'SUCESSO':
          this.repassesMesAnterior = [...response.data.lista];
          break;
        case 'ERRO':
          this.repassesMesAnterior = [];
      }
    },

    limparRepasses() {
      this.repasses = [];
    },

    showLoading() {
      this.isLoading = true;
    },
    hideLoading() {
      this.isLoading = false;
    },

    formatarValor(repasse) {
      return util.formatarValor(repasse.valor);
    },
  },
};
</script>